<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$tt('用户名称')" prop="userName">
                <a-input v-model="queryParam.userId" :placeholder="$tt('请输入用户名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="温度" prop="tem">
                <a-input v-model="queryParam.tem" placeholder="请输入温度" allow-clear/>
              </a-form-item>
            </a-col> -->
            <!-- <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="调节时间" prop="time">
                  <a-input v-model="queryParam.time" placeholder="请输入调节时间" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="预留字段1" prop="strOne">
                  <a-input v-model="queryParam.strOne" placeholder="请输入预留字段1" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="预留字段2" prop="strTwo">
                  <a-input v-model="queryParam.strTwo" placeholder="请输入预留字段2" allow-clear/>
                </a-form-item>
              </a-col>
            </template> -->
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $tt('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $tt('重置') }}</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['cio:setting:add']">
          <a-icon type="plus" />新增
        </a-button> -->
        <!-- <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['cio:setting:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['cio:setting:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['cio:setting:export']">
          <a-icon type="download" />导出
        </a-button> -->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <!-- <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['cio:setting:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['cio:setting:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['cio:setting:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['cio:setting:remove']">
            <a-icon type="delete" />删除
          </a>
        </span> -->
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
:showTotal="total => $tt('共 {p0} 条', { p0: total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { translateText } from '@/locales/text'

import { pageSetting,listSetting, delSetting } from '@/api/cio/setting'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Setting',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        tem: null,
        time: null,
        strOne: null,
        strTwo: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
    
        {
          get title () { return translateText('用户名称') },
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          get title () { return translateText('蓝牙地址') },
          dataIndex: 'strOne',
          ellipsis: true,
          align: 'center'
        },
        {
          get title () { return translateText('温度（°）') },
          dataIndex: 'tem',
          ellipsis: true,
          align: 'center'
        },
        {
          get title () { return translateText('调节时间（分）') },
          dataIndex: 'time',
          ellipsis: true,
          align: 'center'
        },
        {
          get title () { return translateText('设置时间') },
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询用户设置信息列表 */
    getList () {
      this.loading = true
     pageSetting(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        tem: undefined,
        time: undefined,
        strOne: undefined,
        strTwo: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: translateText('确认删除所选中数据?'),
        content: translateText("当前选中编号为{p0}的数据", { p0: ids }),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delSetting(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                translateText('删除成功'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: translateText('是否确认导出?'),
        content: translateText('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('cio/cio-setting/export', {
            ...that.queryParam
          }, translateText('用户设置信息_{p0}.xlsx', { p0: new Date().getTime() }))
        },
        onCancel () {}
      })
    }
  }
}
</script>
